import cn from "classnames"
import React from "react"
import { FormState } from "react-hook-form"
import { IStandardButtonProps, StandardButton } from "swiipe.portal.shared"
import LogInButtonImage from "../../images/icons/log-ind.png"
import SpinnerContainer from "./SpinnerContainer"
import "./SubmitButton.scss"

interface ISubmitButtonProps extends IStandardButtonProps {
    formState: FormState<any>
    containerClass?: string
    floatRight?: boolean
    disableSpinner?: boolean
}

const SubmitButton = ({
    formState,
    disabled,
    className,
    floatRight,
    children,
    containerClass,
    disableSpinner,
    ...otherProps
}: ISubmitButtonProps) => {
    const { isValidating, isSubmitting } = formState

    return (
        <SpinnerContainer
            showSpinner={formState.isSubmitting && !disableSpinner}
            className={cn({ "float-right": floatRight }, containerClass)}
        >
            <StandardButton
                {...otherProps}
                className={cn("swiipe-btn", className)}
                disabled={isValidating || isSubmitting || disabled}
                type="submit"
                variant="primary"
            >
                {children}
            </StandardButton>
        </SpinnerContainer>
    )
}

export default SubmitButton
